// components/MobileNavigation/AboutSection.tsx
import React from 'react';
import NavItemLink from './NavItemLink';

interface AboutSectionProps {
  sections: any[];
  activeItem: string;
  onNavClick: (itemId: string) => void;
}

const AboutSection: React.FC<AboutSectionProps> = ({ sections, activeItem, onNavClick }) => {
  // Reorder sections: move countries (index 1) to last position
  const reorderedSections = [sections[0], sections[2], sections[1]];
  
  return (
    <div className="space-y-4">
      {reorderedSections.map((section, sectionIndex) => (
        <div key={sectionIndex}>
          {section.title && (
            <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-2 px-1">
              {section.title}
            </h4>
          )}
          <div className="space-y-1">
            {section.items.map((subItem: any) => (
              <NavItemLink
                key={subItem.id}
                item={subItem}
                activeItem={activeItem}
                onNavClick={onNavClick}
              />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AboutSection;